module.exports = __webpack_public_path__ + "img/bank-counter-bg-bm.e486e3e2.png";